import { useEffect, useState } from "react";
import { bool } from "prop-types";
import { observer } from "mobx-react";
import { Divider, Fab, Grid, IconButton, Paper, Portal, Slide } from "@material-ui/core";
import { ExpandLess, ExpandMore, MoreVert } from "@material-ui/icons";
import { BOTTOM_BAR_ID } from "@utils";
import { CompactTotals, useEstimateEditorSettings } from "@tools";
import useStyle from "./BottomBar.style";
import { ActionPanel, Versioning } from "./components";

export const BottomBar = observer(({
  summaryHidden,
}) => {
  const { isProposal, isPdfPrinterView, isPresetEditor } = useEstimateEditorSettings();
  const classes = useStyle();

  // Hide bottom bar in print view
  if (isPdfPrinterView) {
    return null;
  }
  
  const [ expanded, setExpanded ] = useState(true);
  const [ userClosed, setUserClosed ] = useState(false);
  const [ menuOpened, setMenuOpened ] = useState(false);
  
  useEffect(() => {
    if(!userClosed)
      setExpanded(summaryHidden);
  }, [summaryHidden]);
  
  const handleOpen = () => {
    if(isPresetEditor)
      return;
    setUserClosed(expanded);
    setExpanded(!expanded);
  }
  
  return <Portal>
    {
      !expanded &&
      <Fab
        color="primary"
        size="small"
        onClick={handleOpen}
        className="preset-bottomBarOpenButton absolute"
        style={{ bottom: 15, left: 16, zIndex: 1000 }}
      >
        <ExpandLess className="text-2xl" />
      </Fab>
    }
    <Slide direction="up" in={expanded}>
      <Paper
        elevation={4}
        id={BOTTOM_BAR_ID}
        className="fixed w-viewport py-2 px-4 preset-paper"
        style={{ bottom: 0, left: 0, zIndex: 1000 }}
      >
        {
          menuOpened &&
          <ActionPanel />
        }
        <Grid item container alignItems="center" wrap="nowrap" className="w-full">
          <IconButton
            color="primary"
            className="preset-bottomBarButton w-40 h-40"
            onClick={handleOpen}
          >
            <ExpandMore />
          </IconButton>
          {
            !isProposal &&
            <IconButton
              color="secondary"
              onClick={() => setMenuOpened(!menuOpened)}
            >
              <MoreVert />
            </IconButton>
          }
          
          <Divider
            dir="vertical"
            className={classes.divider}
          />
          <Versioning />
          <Divider
            dir="vertical"
            className={classes.divider}
          />
          <CompactTotals />
        </Grid>
      </Paper>
    </Slide>
  </Portal>
})

BottomBar.propTypes = {
  show: bool,
}